import axios from "axios";
import { getSector } from "@/lib/sectorStore";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
if (!BACKEND_URL) {
  // Fail loudly instead of silently calling /undefined/api/...
  // eslint-disable-next-line no-console
  console.error("REACT_APP_BACKEND_URL manquant — redémarrez le frontend après avoir défini .env");
}
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "prospee_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const api = axios.create({ baseURL: API });

// Endpoints qui exploitent réellement le contexte sectoriel
const SECTOR_AWARE = ["/companies", "/dashboard", "/export", "/reports", "/pipeline", "/campaigns", "/contacts"];

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Sprint 1 — contexte sectoriel global (Admin/Manager) sur les GET concernés
  const sector = getSector();
  if (config.method === "get" && sector && sector !== "all"
      && SECTOR_AWARE.some((p) => (config.url || "").startsWith(p))) {
    config.params = { ...(config.params || {}), sector_filter: sector };
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith("/connexion")) {
      clearToken();
      window.location.href = "/connexion";
    }
    return Promise.reject(err);
  }
);

export function apiError(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  if (detail.msg) return detail.msg;
  return String(detail);
}

export default api;
